import React, {ReactNode, useEffect, useRef} from 'react';
import {
    Button,
    DialogTitle,
    Flex,
    HTMLDialog,
    Icon,
    PriorityIcon,
    noop
} from '@priority-software/priority-style-react';
import cx from 'classnames';
import styles from './styles.module.scss';
import {localText} from '../../../../hooks/F9Dialog/texts';

type Props = {
    componentClasses?: string;
    isOpen: boolean;
    onClose?: () => void;
    title?: string;
    content?: ReactNode;
    action: () => void;
};

export const DeleteDialog = ({
    componentClasses,
    isOpen,
    onClose,
    title,
    content,
    action
}: Props) => {
    const deleteButtonRef = useRef<HTMLButtonElement>(null);
    useEffect(() => {
        requestAnimationFrame(() => {
            isOpen && deleteButtonRef.current.focus();
        });
    }, [isOpen]);
    return (
        <HTMLDialog
            componentClasses={cx(styles.wrapper, componentClasses)}
            size="small"
            isOpen={isOpen}
            onClose={onClose}
            title={
                <>
                    <Icon
                        hoverable={false}
                        active={false}
                        iconColor="secondary-400"
                        onClick={noop}
                        icon={PriorityIcon.delete}
                        componentClasses={styles.deleteIcon}
                    />
                    <DialogTitle title={title} />
                </>
            }
            content={content}
            footer={
                <Flex componentClasses={styles.footer}>
                    <Button autoFocus skin="secondary" onClick={onClose} width="fullWidth">
                        {localText.cancel}
                    </Button>
                    <Button onClick={action} width="fullWidth" inputRef={deleteButtonRef}>
                        {localText.delete}
                    </Button>
                </Flex>
            }
        />
    );
};
